export const EXECUTIVE = { value: "EXECUTIVE", key: "clientContacts.form.strategicContact.roles.executive" };
export const FINANCE = { value: "FINANCE", key: "clientContacts.form.strategicContact.roles.finance" };
export const HR = { value: "HR", key: "clientContacts.form.strategicContact.roles.hr" };
export const OTHER = { value: "OTHER", key: "clientContacts.form.strategicContact.roles.other" };

export default [EXECUTIVE, FINANCE, HR, OTHER];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/contacts/enums/roleTypes.js